(() => {
  if (window.EurosolApplicationPreviewInitialized) return;
  window.EurosolApplicationPreviewInitialized = true;

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.eurosol-application-preview__toggle');
    if (!toggle) return;

    const card = toggle.closest('.card');
    if (!card) return;

    const isApplicationActive = !card.classList.contains('is-application-active');
    card.classList.toggle('is-application-active', isApplicationActive);
    toggle.setAttribute('aria-pressed', String(isApplicationActive));

    const english = toggle.dataset.locale === 'en';
    const productTitle = toggle.dataset.productTitle || (english ? 'Product' : 'Produkt');
    const label = toggle.querySelector('span');
    if (label) label.textContent = isApplicationActive ? (english ? 'Product' : 'Produkt') : (english ? 'In use' : 'Anwendung');
    toggle.setAttribute(
      'aria-label',
      isApplicationActive
        ? (english ? `Show the product image for ${productTitle}` : `Produktbild für ${productTitle} anzeigen`)
        : (english ? `Show ${productTitle} in use` : `Anwendungsbild für ${productTitle} anzeigen`)
    );
  });
})();
